import { useTranslation } from "react-i18next";
import type { StepComponentType } from "../../hooks/IncorporationWizardFormContext";
import BigCheckGreenIcon from "@assets/icons/big-check-green.svg?raw&inline";

const SuccessStep: StepComponentType = () => {
  const { t } = useTranslation();

  const handleGoToDashboard = () => {
    // TODO: Navigate to dashboard
    window.location.href = "/dashboard"; // Or use your routing solution
  };

  return (
    <section
      className="container"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        maxWidth: 800,
        margin: "0 auto",
        padding: "2rem",
      }}
    >
      <div
        className="d-flex flex-column align-items-center text-center"
        style={{ maxWidth: "600px" }}
      >
        {/* Large Green Checkmark Icon */}
        <div
          className="mb-4"
          style={{
            width: "120px",
            height: "120px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          dangerouslySetInnerHTML={{ __html: BigCheckGreenIcon }}
        />

        {/* Success Heading */}
        <h1
          className="fw-bold mb-4"
          style={{
            fontSize: "28px",
            lineHeight: "1.2",
            color: "#000",
          }}
        >
          {t("success.title")}
        </h1>

        {/* Information Text */}
        <div
          className="d-flex flex-column gap-3 mb-5"
          style={{
            fontSize: "16px",
            lineHeight: "1.6",
            color: "#6c757d",
            textAlign: "left",
          }}
        >
          <p className="mb-0">{t("success.description.verification")}</p>
          <p className="mb-0">{t("success.description.timeline")}</p>
          <p className="mb-0">{t("success.description.tracking")}</p>
        </div>

        {/* Go to Dashboard Button */}
        <button
          type="button"
          className="btn btn-dark"
          onClick={handleGoToDashboard}
          style={{
            padding: "12px 32px",
            fontSize: "16px",
            borderRadius: "8px",
            fontWeight: 500,
          }}
        >
          {t("success.go_to_dashboard")}
        </button>
      </div>
    </section>
  );
};

SuccessStep.title = (t) => t("success.title");
SuccessStep.description = (t) => t("success.description_progress_panel");
// SuccessStep.isComplete = (_data: IncorporationWizardInitialData) => true; // Always complete o usar todo el schema para determinar?
SuccessStep.hideFromProgressPanel = true; // Hide from progress panel since it's the final step

export default SuccessStep;

